import React from "react";

const Countdown = ({ date, labels }) => {
  const {
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0
  } = date;

  return (
    <div className="contentOverviewCountdown">
      <p className="countdownTitle">
        {labels?.available_live_on}
      </p>

      <div className="countdownContainer">
        <div className="countdownBox">
          <p className="countdownNumber">
            {days > 0 ?
              days >= 10 ? days : `0${days}` :
              hours >= 10 ? hours : `0${hours}`
            }
          </p>
          <p className="countdownLabel">
            {days > 0 ? 'ds' : 'hrs'}
          </p>
        </div>

        <div className="countdownBox">
          <p className="countdownNumber">
            {days > 0 ?
              hours >= 10 ? hours : `0${hours}` :
              minutes >= 10 ? minutes : `0${minutes}`
            }
          </p>
          <p className="countdownLabel">
            {days > 0 ? 'hrs' : 'min'}
          </p>
        </div>

        <div className="countdownBox">
          <p className="countdownNumber">
            {days > 0 ?
              minutes >= 10 ? minutes : `0${minutes}` :
              seconds >= 10 ? seconds : `0${seconds}`
            }
          </p>
          <p className="countdownLabel">
            {days > 0 ? 'min' : 'seg'}
          </p>
        </div>
      </div>
    </div>
  )
}

export default Countdown;
